import { useState, useRef, useEffect } from "react";

const ITEMS = [
  {
    num: "01", tag: "Rentabilité",
    label: "Améliorez votre rentabilité",
    descBefore: "Boostez votre ",
    descHighlight: "rentabilité",
    descAfter: " grâce à vos démarches responsables.",
    icon: (
      <svg viewBox="0 0 64 64" fill="none" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <ellipse cx="32" cy="18" rx="18" ry="8"/>
        <path d="M14 18v10c0 4.418 8.059 8 18 8s18-3.582 18-8V18"/>
        <path d="M14 28v10c0 4.418 8.059 8 18 8s18-3.582 18-8V28"/>
      </svg>
    ),
  },
  {
    num: "02", tag: "Clients",
    label: "Trouvez et fidélisez vos clients",
    descBefore: "Attirez de nouveaux marchés grâce à vos ",
    descHighlight: "engagements",
    descAfter: " responsables.",
    icon: (
      <svg viewBox="0 0 64 64" fill="none" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="28" cy="28" r="16"/>
        <path d="m50 50-8-8"/>
        <circle cx="28" cy="24" r="6"/>
        <path d="M18 40c0-5.523 4.477-8 10-8s10 2.477 10 8"/>
      </svg>
    ),
  },
  {
    num: "03", tag: "RH",
    label: "Attirez des talents",
    descBefore: "Faites de votre engagement votre meilleur ",
    descHighlight: "atout RH",
    descAfter: " et marque employeur.",
    icon: (
      <svg viewBox="0 0 64 64" fill="none" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M42 56v-6a10 10 0 0 0-10-10H16a10 10 0 0 0-10 10v6"/>
        <circle cx="24" cy="22" r="10"/>
        <path d="M56 56v-6a10 10 0 0 0-8-9.8M42 12.2a10 10 0 0 1 0 19.4"/>
      </svg>
    ),
  },
  {
    num: "04", tag: "Innovation",
    label: "Innovez grâce au vivant",
    descBefore: "Inventez de nouveaux produits en vous inspirant du ",
    descHighlight: "biomimétisme",
    descAfter: " et des solutions offertes par la nature.",
    icon: (
      <svg viewBox="0 0 64 64" fill="none" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M32 56C14 56 6 42 6 24c18 0 26 10 26 32z"/>
        <path d="M32 56c18 0 26-14 26-32-18 0-26 10-26 32z"/>
        <path d="M32 18v38"/>
      </svg>
    ),
  },
  {
    num: "05", tag: "Conformité",
    label: "Anticipez et maîtrisez les réglementations",
    descBefore: "Connaître vos droits et vos devoirs pour",
    descHighlight: " les anticiper et éviter",
    descAfter: " les sanctions coûteuses.",
    icon: (
      <svg viewBox="0 0 64 64" fill="none" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M32 6L8 16v16c0 14.667 10.667 26.667 24 30 13.333-3.333 24-15.333 24-30V16L32 6z"/>
        <path d="m22 32 7 7 13-13"/>
      </svg>
    ),
  },
  {
    num: "06", tag: "Réputation",
    label: "Améliorez votre image",
    descBefore: "Renforcez la ",
    descHighlight: "confiance",
    descAfter: " de vos parties prenantes et différenciez-vous.",
    icon: (
      <svg viewBox="0 0 64 64" fill="none" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="32" cy="22" r="10"/>
        <path d="M12 52c0-11.046 8.954-18 20-18s20 6.954 20 18"/>
      </svg>
    ),
  },
  {
    num: "07", tag: "Avenir",
    label: "Sécurisez et pérennisez votre activité",
    descBefore: "Construisez une ",
    descHighlight: "croissance durable",
    descAfter: " sur le long terme en anticipant les mutations",
    icon: (
      <svg viewBox="0 0 64 64" fill="none" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="32" cy="32" r="10"/>
        <path d="M32 8v6M32 50v6M8 32h6M50 32h6M14.1 14.1l4.2 4.2M45.7 45.7l4.2 4.2M45.7 14.1l-4.2 4.2M14.1 45.7l4.2 4.2"/>
      </svg>
    ),
  },
];

const DOTS_DATA = [
  [120,80,3],[1080,110,1.5],[1140,600,4],[60,650,2],[600,30,1],
  [300,450,3.5],[900,350,1.5],[450,200,2.5],[750,500,1],[200,300,4],
  [1000,450,2],[350,150,1.5],[650,650,3],[850,150,2],[500,550,1],
  [150,500,3.5],[1050,250,1.5],[700,100,2.5],[250,700,1],[1000,700,2],[400,700,3],
];

function Carousel({ current, onSelect, mobile, onNavigate }) {
  const N = ITEMS.length;
  const RADIUS = mobile ? 200 : 320;
  const rotRef = useRef(0);
  const ringRef = useRef(null);
  const wrapRef = useRef(null);
  const currentRef = useRef(current);
  const lastWheelRef = useRef(0);
  const touchXRef = useRef(0);
  const touchYRef = useRef(0);

  // Sync rotation when current changes externally (pills click)
  useEffect(() => {
    const diff = current - currentRef.current;
    const short = ((diff + N / 2) % N) - N / 2;
    rotRef.current -= (360 / N) * short;
    currentRef.current = current;
    applyRotation();
  }, [current]);

  function applyRotation() {
    if (!ringRef.current) return;
    ringRef.current.style.transform = `rotateY(${rotRef.current}deg)`;
    Array.from(ringRef.current.children).forEach((card, i) => {
      const cardAngle = (360 / N) * i;
      const rel = ((cardAngle + rotRef.current) % 360 + 360) % 360;
      const isActive = rel < 25 || rel > 335;
      const isSide = (rel >= 25 && rel < 80) || (rel > 280 && rel <= 335);
      const isBack = rel >= 80 && rel <= 280;
      const scale = isActive ? 1.18 : isSide ? 0.78 : 0.65;
      card.style.opacity = isBack ? "0" : isActive ? "1" : isSide ? "0.35" : "0.1";
      card.style.background = isActive ? "rgba(0,165,178,0.1)" : "rgba(255,255,255,0.04)";
      card.style.borderColor = isActive ? "rgba(0,165,178,0.5)" : "rgba(255,255,255,0.1)";
      card.style.transform = `rotateY(${cardAngle}deg) translateZ(${RADIUS}px) scale(${scale})`;
    });
  }

  function go(dir) {
    const next = ((currentRef.current + dir) % N + N) % N;
    rotRef.current -= (360 / N) * dir;
    currentRef.current = next;
    applyRotation();
    onSelect(next);
  }

  // Wheel — desktop only
  useEffect(() => {
    const el = wrapRef.current;
    if (!el || mobile) return;
    const handleWheel = (e) => {
      e.preventDefault();
      const now = Date.now();
      if (now - lastWheelRef.current < 600) return;
      lastWheelRef.current = now;
      if (e.deltaY > 0) go(1);
      else go(-1);
    };
    el.addEventListener("wheel", handleWheel, { passive: false });
    return () => el.removeEventListener("wheel", handleWheel);
  }, [mobile]);

  // Touch — mobile only
  const onTouchStart = (e) => {
    touchXRef.current = e.touches[0].clientX;
    touchYRef.current = e.touches[0].clientY;
  };
  const onTouchMove = (e) => {
    const dx = Math.abs(e.touches[0].clientX - touchXRef.current);
    const dy = Math.abs(e.touches[0].clientY - touchYRef.current);
    if (dx > dy && dx > 5) e.preventDefault();
  };
  const onTouchEnd = (e) => {
    const diff = touchXRef.current - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 40) {
      if (diff > 0) go(1);
      else go(-1);
    }
  };

  const cardW = mobile ? 170 : 250;
  const cardH = mobile ? 280 : 360;

  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
      <div
        ref={wrapRef}
        onTouchStart={onTouchStart}
        onTouchMove={onTouchMove}
        onTouchEnd={onTouchEnd}
        style={{
          flex: 1,
          perspective: 1800,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          overflow: "visible",
          touchAction: "pan-y",
          userSelect: "none",
          cursor: mobile ? "default" : "ns-resize",
          minHeight: mobile ? 360 : 520,
        }}
      >
        <div
          ref={ringRef}
          style={{
            width: cardW,
            height: cardH,
            position: "relative",
            transformStyle: "preserve-3d",
            transition: "transform 0.7s cubic-bezier(0.4,0,0.2,1)",
          }}
        >
          {ITEMS.map((item, i) => {
            const angle = (360 / N) * i;
            return (
              <div
                key={i}
                onClick={() => {
                  const diff = i - currentRef.current;
                  const short = ((diff + N / 2) % N) - N / 2;
                  if (short !== 0) go(short > 0 ? 1 : -1);
                }}
                style={{
                  position: "absolute",
                  width: cardW, height: cardH,
                  borderRadius: 20,
                  padding: mobile ? "1.4rem 1rem" : "1.8rem 1.4rem",
                  display: "flex", flexDirection: "column",
                  alignItems: "center", justifyContent: "center",
                  textAlign: "center", gap: 12,
                  transform: `rotateY(${angle}deg) translateZ(${RADIUS}px)`,
                  transition: "background 0.5s, border-color 0.5s, opacity 0.5s, transform 0.5s cubic-bezier(0.4,0,0.2,1)",
                  background: "rgba(255,255,255,0.04)",
                  border: "1px solid rgba(255,255,255,0.1)",
                  overflow: "hidden",
                  fontFamily: "'Montserrat', sans-serif",
                  cursor: "pointer",
                }}
              >
                <div style={{ width: mobile ? 64 : 72, height: mobile ? 64 : 72, flexShrink: 0 }}>{item.icon}</div>
                <div style={{ fontSize: mobile ? 12 : 13, fontWeight: 700, color: "#fff", textTransform: "uppercase", letterSpacing: "0.07em", lineHeight: 1.3 }}>
                  {item.label}
                </div>
                <div style={{ width: 24, height: 2, background: "rgba(255,255,255,0.2)", borderRadius: 2, flexShrink: 0 }} />
                <div style={{ fontSize: mobile ? 11 : 12, color: "rgba(255,255,255,0.6)", lineHeight: 1.6, flexGrow: 1 }}>
                  {item.descBefore}
                  <span style={{ color: "#9fc131" }}>{item.descHighlight}</span>
                  {item.descAfter}
                </div>
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    const routes = ['/blog/rentabilite/index.html','/blog/clients/','/blog/rh/','/blog/innovation/','/blog/conformite/','/blog/reputation/','/blog/avenir/'];
                    window.location.href = (routes[i] || '/blog/rentabilite/index.html') + '?from=menu';
                  }}
                  style={{
                    display: "inline-flex", alignItems: "center", gap: mobile ? 6 : 8,
                    background: "#00A5B2", color: "#fff",
                    fontFamily: "'Montserrat', sans-serif",
                    fontSize: mobile ? 10 : 12, fontWeight: 700, letterSpacing: "0.06em",
                    border: "none", borderRadius: 999,
                    padding: mobile ? "8px 14px" : "10px 20px", cursor: "pointer", flexShrink: 0,
                  }}
                >
                  Je me lance
                  <svg width="11" height="11" viewBox="0 0 12 12" fill="none">
                    <path d="M2.5 6h7M6.5 3l3 3-3 3" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </button>
              </div>
            );
          })}
        </div>
      </div>

      {/* Dots */}
      <div style={{ display: "flex", justifyContent: "center", gap: 7, marginTop: 36 }}>
        {ITEMS.map((_, i) => (
          <div key={i} onClick={() => onSelect(i)} style={{
            width: i === current ? 22 : 7, height: 7,
            borderRadius: i === current ? 4 : "50%",
            background: i === current ? "#00A5B2" : "rgba(255,255,255,0.2)",
            cursor: "pointer", transition: "all 0.2s",
          }} />
        ))}
      </div>
    </div>
  );
}

export default function MenuPage({ onBack, initialIndex = 0, onNavigate }) {
  const [current, setCurrent] = useState(initialIndex);
  const [mobile, setMobile] = useState(() => typeof window !== "undefined" ? window.innerWidth < 768 : false);

  useEffect(() => {
    const fn = () => setMobile(window.innerWidth < 768);
    window.addEventListener("resize", fn);
    return () => window.removeEventListener("resize", fn);
  }, []);

  const pillsRow1 = ITEMS.slice(0, 4); // ← prend les 4 premiers items (Rentabilité, Clients, RH, Innovation)
  const pillsRow2 = ITEMS.slice(4);    // ← prend les 3 derniers (Conformité, Réputation, Avenir)

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700;800&display=swap');
        * { box-sizing: border-box; margin: 0; padding: 0; }
        body { background: #001c2b; }
        @keyframes pulseScale {
          0%,100% { transform: scale(1); }
          50%      { transform: scale(1.06); }
        }
        @keyframes fadeUp {
          from { opacity: 0; transform: translateY(12px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        @keyframes lineGrow {
          to { transform: scaleX(1); }
        }
        .pill-btn { transition: all 0.2s; }
        .pill-btn:hover { background: rgba(0,165,178,0.08) !important; border-color: rgba(0,165,178,0.4) !important; color: #fff !important; }
      `}</style>

      <div style={{
        background: "#001c2b",
        minHeight: "100vh",
        fontFamily: "'Montserrat', sans-serif",
        position: "relative",
        overflowX: "hidden",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        paddingTop: 80,
        isolation: "auto",
      }}>
        {/* Orbs */}
        {[
          { w:500, h:500, top:-200,               right:-150, dur:"7s",  del:"0s"  },
          { w:400, h:400, top:"calc(50% - 200px)", left:-180,  dur:"9s",  del:"2s"  },
          { w:350, h:350, bottom:-150,             right:-120, dur:"8s",  del:"4s"  },
        ].map((o,i) => (
          <div key={i} style={{
            position:"fixed", borderRadius:"50%", pointerEvents:"none",
            width:o.w, height:o.h, background:"#fff", opacity:0.01,
            top:o.top, right:o.right, bottom:o.bottom, left:o.left,
            animation:`pulseScale ${o.dur} ${o.del} ease-in-out infinite`,
          }}/>
        ))}

        {/* Deco dots */}
        <svg style={{ position:"absolute", inset:0, width:"100%", height:"100%", pointerEvents:"none", zIndex:1 }}
          viewBox="0 0 1200 800" fill="none" preserveAspectRatio="xMidYMid slice">
          {DOTS_DATA.map(([cx,cy,r],i) => <circle key={i} cx={cx} cy={cy} r={r} fill="#fff" opacity="0.1"/>)}
        </svg>

        {/* Content */}
        <div style={{
          position: "relative", zIndex: 2,
          width: "100%",
          padding: mobile ? "5rem 1.6rem" : "5rem 13%",
          ...(mobile ? {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          } : {
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: "4rem",
            alignItems: "center",
            minHeight: "80vh",
          }),
        }}>

          {/* ── LEFT ── */}
          <div style={{
            marginBottom: mobile ? "3rem" : 0,
            ...(mobile ? {} : {
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              paddingLeft: 0,
              marginLeft: "-2rem",
            }),
          }}>
            <h1 style={{
              fontSize: mobile ? 32 : 42,
              fontWeight: 800, color: "#fff",
              lineHeight: 1.2, marginBottom: mobile ? "1.5rem" : "1.5rem",
              textAlign: mobile ? "center" : "left",
              animation: "fadeUp 0.6s ease both",
            }}>
              Des démarches<br/>
              <em style={{
                fontStyle: "normal",
                color: "#9fc131",
                position: "relative",
                display: "inline-block",
              }}>
                responsables
                <span style={{
                  position: "absolute",
                  left: 0, bottom: -2,
                  width: "100%", height: 3,
                  background: "#9fc131",
                  borderRadius: 2,
                  transform: "scaleX(0)",
                  transformOrigin: "left",
                  animation: "lineGrow 0.6s 0.8s ease forwards",
                  display: "block",
                }} />
              </em><br/>
              pour servir<br/>
              vos enjeux...
            </h1>

            {/* Pills */}
            <div style={{ animation:"fadeUp 0.6s 0.15s ease both", paddingBottom: mobile ? 0 : 40 }}>
              {mobile ? (
                <>
                  <div style={{ display:"grid", gridTemplateColumns:`repeat(${pillsRow1.length}, 1fr)`, gap:6, marginBottom:6 }}>
                    {pillsRow1.map((item,i) => (
                      <button key={i} className="pill-btn" onClick={() => setCurrent(i)} style={{
                        padding: "10px 6px", borderRadius: 8,
                        border: `1px solid ${current===i ? "rgba(0,165,178,0.6)" : "rgba(255,255,255,0.3)"}`,
                        background: current===i ? "rgba(0,165,178,0.12)" : "transparent",
                        color: current===i ? "#fff" : "rgba(255,255,255,0.65)",
                        fontFamily:"'Montserrat',sans-serif", fontSize:12, fontWeight:500,
                        cursor:"pointer", textAlign:"center",
                        textDecoration: current===i ? "none" : "underline",
                        whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis",
                        height: 40,
                      }}>
                        {item.tag}
                      </button>
                    ))}
                  </div>
                  <div style={{ display:"grid", gridTemplateColumns:`repeat(${pillsRow2.length}, 1fr)`, gap:6 }}>
                    {pillsRow2.map((item,i) => (
                      <button key={i} className="pill-btn" onClick={() => setCurrent(i+4)} style={{
                        padding: "10px 6px", borderRadius: 8,
                        border: `1px solid ${current===i+4 ? "rgba(0,165,178,0.6)" : "rgba(255,255,255,0.3)"}`,
                        background: current===i+4 ? "rgba(0,165,178,0.12)" : "transparent",
                        color: current===i+4 ? "#fff" : "rgba(255,255,255,0.65)",
                        fontFamily:"'Montserrat',sans-serif", fontSize:12, fontWeight:500,
                        cursor:"pointer", textAlign:"center",
                        textDecoration: current===i+4 ? "none" : "underline",
                        whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis",
                        height: 40,
                      }}>
                        {item.tag}
                      </button>
                    ))}
                  </div>
                </>
              ) : (
                <>
                  <div style={{ display:"flex", gap:14, flexWrap:"wrap", justifyContent:"flex-start", marginBottom:10 }}>
                    {pillsRow1.map((item,i) => (
                      <button key={i} className="pill-btn" onClick={() => setCurrent(i)} style={{
                        padding: "11px 20px", borderRadius: 8,
                        border: `1px solid ${current===i ? "rgba(0,165,178,0.6)" : "rgba(255,255,255,0.3)"}`,
                        background: current===i ? "rgba(0,165,178,0.12)" : "transparent",
                        color: current===i ? "#fff" : "rgba(255,255,255,0.65)",
                        fontFamily:"'Montserrat',sans-serif", fontSize:15, fontWeight:500,
                        cursor:"pointer",
                        textDecoration: current===i ? "none" : "underline",
                      }}>
                        {item.tag}
                      </button>
                    ))}
                  </div>
                  <div style={{ display:"flex", gap:14, flexWrap:"wrap", justifyContent:"flex-start" }}>
                    {pillsRow2.map((item,i) => (
                      <button key={i} className="pill-btn" onClick={() => setCurrent(i+4)} style={{
                        padding: "11px 20px", borderRadius: 8,
                        border: `1px solid ${current===i+4 ? "rgba(0,165,178,0.6)" : "rgba(255,255,255,0.3)"}`,
                        background: current===i+4 ? "rgba(0,165,178,0.12)" : "transparent",
                        color: current===i+4 ? "#fff" : "rgba(255,255,255,0.65)",
                        fontFamily:"'Montserrat',sans-serif", fontSize:15, fontWeight:500,
                        cursor:"pointer",
                        textDecoration: current===i+4 ? "none" : "underline",
                      }}>
                        {item.tag}
                      </button>
                    ))}
                  </div>
                </>
              )}
            </div>
          </div>

          {/* ── RIGHT ── */}
          <div style={{
            animation:"fadeUp 0.6s 0.25s ease both",
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            paddingRight: mobile ? 0 : "3rem",
          }}>
            <Carousel current={current} onSelect={setCurrent} mobile={mobile} onNavigate={onNavigate}/>
          </div>

        </div>
      </div>
    </>
  );
}
